<button *ngIf="options.closeButton" (click)="remove()" class="toast-close-button" aria-label="Close">
  <span aria-hidden="true">&times;</span>
</button>
<div role="alertdialog" aria-live="polite" [class]="options.messageClass">
  {{ message }} <a (click)="goToRights()">here</a>
</div>
